const date = new Date();
const year = date.getFullYear();

const APPCONFIG = {
	brand: 'ServiceBookr',
	year,
	copyright: '2019',
	productLink: 'https://app.karlstechnology.com',
	settings: {
		isDev: () => {
			return !process.env.production
		},
		isBeta: () => {
			return window.location.hostname === 'beta.karlstechnology.com'
		},
		apiURL: () => {
			return window.location.hostname === 'beta.karlstechnology.com' ? "https://beta.api.karlstechnology.com" : (
				window.location.hostname === 'app.karlstechnology.com' ?
					'https://api.karlstechnology.com' :
					'https://dev.api.karlstechnology.com');
		},
		GOOGLE_MAPS_API_KEY: () => {
			return window.location.hostname === 'beta.karlstechnology.com' ? "AIzaSyB3dWCrg90COU1QVwo4htdE4OLeZ4fQrwM" : (
				window.location.hostname === 'app.karlstechnology.com' ?
					'AIzaSyDP0S_9Oe4uoF70-n0JzzWO1lIsmLoxg7s' :
					'AIzaSyB4p4vhCAbwz6yD-PQ6HgY3DEz3GyGLtnw');
		},
		executiveDashboardRefreshMs: 5 * 60 * 1000,
		apiVersion: 'v694'
	}
};

export default APPCONFIG;
